import { NETWORK_ERROR_CODE } from '../services/network-error';

/**
 * Il codice dell'errore, da qualunque forma arrivi.
 *
 * Nel client un guasto si presenta in tre modi, e chi lo consuma non deve
 * doverli conoscere:
 *
 * 1. `ArenaSocketError` — il rifiuto di un gestore socket: il codice sta in
 *    `.code`, insieme alla frase inglese per i log.
 * 2. `ApiRequestError` — la risposta HTTP non-ok passata da `buildApiError`:
 *    anche qui `.code`, accanto a `.status`.
 * 3. `Error` nudo con `message === NETWORK_ERROR_CODE` — la rete caduta.
 *    Questa e' la forma che si dimentica, perche' e' l'unica dove il codice NON
 *    sta in `.code`: `api.ts` lo lancia come messaggio. Scrivere il pattern
 *    naturale `chiave((err as ApiRequestError).code)` vuol dire mostrare
 *    «errore sconosciuto» proprio nel caso piu' comune di tutti.
 *
 * Tutto il resto — un `Error` con una frase qualunque, o un `throw` di
 * qualcosa che non e' nemmeno un oggetto — non ha codice: `undefined`, e chi
 * traduce ripieghera' sulla frase generica. Solo il sentinella della rete
 * viaggia nel messaggio: leggere ogni `message` come codice vorrebbe dire
 * cercare `relation "arenas" does not exist` dentro una mappa di codici.
 *
 * Il riconoscimento e' per forma, non per `instanceof`: `services/socket.ts`
 * viene sostituito da un finto nei test, e un `instanceof` contro la classe
 * vera fallirebbe proprio li' dove serve. Anche l'import sarebbe di troppo —
 * questo file lo importa chi importa socket: una freccia in meno e una
 * dipendenza circolare in meno.
 *
 * ⚠️ Sta qui, con un nome neutro, e non piu' dentro `arena-error-key`: la
 * dashboard e la lista dei collegati hanno la stessa identica domanda, e
 * riscrivere la trappola del punto 3 una seconda volta e' il modo sicuro di
 * sbagliarla — infatti in `OnlinePlayersList` era gia' sbagliata, con il
 * `message` inglese stampato a schermo.
 */
export function codiceErrore(err: unknown): string | undefined {
  if (typeof err !== 'object' || err === null) return undefined;
  const { code, message } = err as { code?: unknown; message?: unknown };
  if (typeof code === 'string' && code.length > 0) return code;
  if (message === NETWORK_ERROR_CODE) return NETWORK_ERROR_CODE;
  return undefined;
}
